<template>
  <AdminContainer>
    <div class="wrapper-container">
      <div class="container-widget-header">
        <h3>CONTACTS</h3>
        <div class="call-actions">
          <button class="btn-success" @click="addNew()">
            <img src="@/assets/images/icons/plus.svg" /> CREATE CONTACTS
          </button>
          <button class="btn-success" @click="importContact()">
            <img src="@/assets/images/icons/plus.svg" /> IMPORT CONTACTS
          </button>
          <button class="btn-success" @click="show_message_form = true">
            SEND SMS
          </button>
          <input type="file" style="display: none" id="file" ref="file" accept=".vcf"
            v-on:change="handleFileUpload()" />
        </div>
      </div>
      <div class="body-widget">
        <div class="table-widget">
          <table>
            <tr>
              <th>Phone number</th>
              <th></th>
            </tr>
            <tr v-for="(item, index) in contacts_data" :key="index">
              <td>{{ item.phone }}</td>

              <td>
                <dropdown-menu v-model="item.is_menu_open" :right="false" :hover="false" :interactive="true"
                  class="shop-menu">
                  <button class="dropdown-toggle">
                    <img src="@/assets/images/icons/menu.svg" />
                  </button>
                  <div slot="dropdown" class="drop-down-menu">
                    <a class="dropdown-item" @click.prevent="editItem(item)">
                      <img src="@/assets/images/icons/edit.svg" /> Edit
                    </a>
                    <a class="dropdown-item" @click.prevent="deleteItem(item)">
                      <img src="@/assets/images/icons/trash.svg" /> Delete
                    </a>
                  </div>
                </dropdown-menu>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <!-- Add Modal -->
      <div class="overlay" v-if="show_form">
        <div class="form-widget">
          <div class="header">
            <h3 v-if="!form.id">Add Contact</h3>
            <h3 v-else>Update Contact</h3>
          </div>
          <div class="body">
            <div class="input-group">
              <label>Phone number</label>
              <div class="input-widget">
                <input type="text" v-model="form.phone_number" class="bg-cagura-form-control" />
              </div>
            </div>
          </div>
          <div class="footer">
            <c-button :loading="loading" @click="submitForm()" class="btn-success">Save</c-button>
            <button @click="show_form = false" class="btn-default">
              Cancel
            </button>
          </div>
        </div>
      </div>

      <div class="overlay" v-if="show_message_form">
        <div class="form-widget">
          <div class="header">
            <h3>Send Message</h3>
          </div>
          <div class="body">
            <div class="input-group">
              <label>Message</label>
              <div class="input-widget">
                <textarea type="text" class="bg-cagura-textarea-form-control" v-model="message"></textarea>
              </div>
            </div>
          </div>
          <div class="footer">
            <c-button :loading="send_loading" @click="sendMessage()" class="btn-success">Send</c-button>
            <button @click="show_message_form = false" class="btn-default">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </AdminContainer>
</template>

<script>
export default {
  components: {},
  data: () => ({
    menu: false,
    loading: false,
    form: {
      id: null,
      phone_number: "",
    },
    show_form: false,
    contacts_data: [],
    file: "",
    show_message_form: false,
    message: "",
    send_loading: false,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getContacts();
  },
  methods: {
    sendMessage() {
      let vm = this;
      if (vm.message.length > 50) {
        vm.send_loading = true;
        vm.$store
          .dispatch("SEND_MESSAGE", { message: vm.message })
          .then((response) => {
            vm.send_loading = false;
            vm.show_message_form = false;
            vm.message = "";
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            console.error("SEND_MESSAGE", { response });
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
          });
      } else {
        vm.$notify({
          group: "status",
          type: "warn",
          title: "OOPS!!!",
          text: "Type something important....",
        });
      }
    },
    importContact() {
      document.querySelector("#file").click();
    },
    handleFileUpload() {
      let vm = this;
      vm.file = vm.$refs.file.files[0];
      if (vm.file) {
        let formData = new FormData();
        formData.append("file", this.file);
        vm.$store
          .dispatch("IMPORT_CONTACTS", formData)
          .then((response) => {
            vm.getContacts();
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            console.error("IMPORT_CONTACTS", { response });
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
          });
      }
    },
    confirmDelete(id) {
      let vm = this;
      vm.$store
        .dispatch("DELETE_CONTACT_ITEM", { id: id })
        .then((response) => {
          vm.getContacts();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Important message",
            text: response.data.message,
          });
        })
        .catch(({ response }) => {
          console.error("DELETE_CONTACT_ITEM", { response });
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: response.data.message,
          });
        });
    },
    deleteItem(item) {
      let vm = this;
      vm.$confirm({
        title: "Confirm",
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            vm.confirmDelete(item.id);
          }
        },
      });
    },
    editItem(item) {
      let vm = this;
      vm.form.id = item.id;
      vm.form.phone_number = item.phone;
      vm.show_form = true;
    },
    getContacts() {
      let vm = this;
      vm.$store
        .dispatch("GET_ALL_CONTACTS")
        .then((response) => {
          vm.contacts_data = response.data.return.map((item) => {
            vm.$store.state.eventBus.$set(item, "is_menu_open", false);
            return item;
          });
        })
        .catch(({ response }) => {
          console.log("GET_ALL_CONTACTS", { error });
        });
    },
    submitForm() {
      let vm = this;
      vm.loading = true;
      if (!vm.form.id) {
        vm.$store
          .dispatch("CONTACTS_ADD_ITEM", vm.form)
          .then((response) => {
            vm.loading = false;
            vm.getContacts();
            vm.show_form = false;
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
            console.log("CONTACTS_ADD_ITEM", { error });
          });
      } else {
        vm.$store
          .dispatch("CONTACTS_UPDATE_ITEM", vm.form)
          .then((response) => {
            vm.loading = false;
            vm.getContacts();
            vm.show_form = false;
            vm.$notify({
              group: "status",
              type: "success",
              title: "Important message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
            console.log("CONTACTS_UPDATE_ITEM", { error });
          });
      }
    },
    addNew() {
      let vm = this;
      vm.show_form = true;
      vm.form = {
        id: null,
        phone_number: "",
      };
    },
    onAffiliateImageSelected(file) {
      let vm = this;
      vm.form.main_image = file;
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper-container {
  display: flex;
  flex-direction: column;

  .container-widget-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;

    .call-actions {
      display: flex;

      button {
        margin-left: 10px;
      }
    }
  }

  .body-widget {
    height: calc(100vh - 122px);
    overflow-y: auto;

    .table-widget {
      width: 100%;
      padding: 0px 10px;

      table {
        width: 100%;

        th {
          height: 45px;
          background: #ddd;
          border: 1px solid #fff;
          padding: 15px;
        }

        td {
          border: 1px solid #ddd;
          padding: 15px;

          .shop-menu {
            position: relative;
          }

          .affiliate-image {
            width: 40px;
            height: 40px;
          }
        }
      }
    }
  }

  .overlay {
    display: flex;
    justify-content: center;
    padding-top: 80px;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    align-items: unset;

    .form-widget {
      height: 600px;
      width: 400px;
      background: #fff;
      border: 1px solid #ccc;
      border-radius: 5px;
      display: flex;
      flex-direction: column;

      .header {
        height: 60px;
        display: flex;
        align-items: center;
        padding: 0px 15px;
        border-bottom: 1px solid #ccc;

        h3 {
          margin: 0px;
        }
      }

      .body {
        height: calc(100% - 120px);
        overflow-y: auto;
        padding: 15px;
      }

      .footer {
        background: rgb(250, 250, 250);
        border-top: 1px solid #ccc;
        height: 60px;
        display: flex;
        align-items: center;
        padding: 0px 15px;

        button {
          margin-right: 20px;
        }
      }
    }
  }

  .on-fly-options {
    position: fixed;
    bottom: 20px;
    right: 20px;

    .btn-cycle {
      height: 50px !important;
      width: 50px !important;
      min-width: 50px !important;
      border-radius: 50%;
      font-size: 29px;
      background: #fff;
      box-shadow: 0px 0px 6px #000;
    }
  }
}
</style>
